export enum OrderNotesFormFields {
    ORDER_NOTES = 'orderNotes',
}
